var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tab-layout', {
    attrs: {
      "tabs": _vm.tabs,
      "isLoading": _vm.isLoading
    },
    on: {
      "update:tab": _vm.setActiveTab
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn(_ref) {
        var isMobile = _ref.isMobile;
        return [!isMobile ? _c('v-btn', {
          attrs: {
            "block": "",
            "text": ""
          },
          on: {
            "click": function click() {
              return _vm.ticketTableCard.openCreateDialog();
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("project.ticket.newTicket")) + " ")], 1) : _vm._e()];
      }
    }])
  }, [[_vm.activeTab ? _c('ticket-table', {
    key: 'ticket-table-' + _vm.activeTab.id,
    ref: "ticketTableCard",
    attrs: {
      "refs": [_vm.ref],
      "partnerId": _vm.partner.id,
      "tags": _vm.activeTab.tag ? [_vm.activeTab.tag] : [],
      "filters": _vm.filters,
      "hideCreateButton": false
    }
  }) : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }